// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"900d5a2d","213":"c34b2b5d","328":"2edb0707","806":"d0595635"}[chunkId] + ".chunk.js";
};